import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty } from "class-validator";

export class ColumnsDtoActive{
    @ApiProperty()
    columnsId:number;

    @ApiProperty()
    versionFlag: number;

    @ApiProperty()
    isActive : boolean;

    @ApiProperty()
    updatedUser : string;



}